var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBinance = function SvgBinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#F0B90B",
    rx: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.48 50 .036 13.222 11.234 6.61v7.74L20.942 67.129V46.134zm0-13.22v7.704l-6.542-3.87v-7.705l6.542-3.87 6.574 3.87zm15.961-3.87 6.543-3.87 6.575 3.87-6.575 3.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.207 60.481v-7.74l6.542 3.87v7.705zm11.234 12.124 6.542 3.87 6.575-3.87v7.704l-6.574 3.87-6.543-3.87zm22.5-39.696 6.543-3.87 6.574 3.87v7.705l-6.574 3.87v-7.705zm6.543 30.313L72.519 50l6.543-3.87v20.993L61.254 77.569v-7.74z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m67.793 60.483-6.543 3.834v-7.705l6.543-3.87z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m67.792 39.52.036 7.74-11.266 6.611v13.253L50.02 70.96l-6.543-3.835V53.871l-11.266-6.61v-7.74l6.57-3.871 11.199 6.643 11.266-6.643 6.574 3.87zM32.207 26.303l17.777-10.48 17.808 10.48-6.543 3.87-11.266-6.642-11.233 6.642z"
  })));
};
export default SvgBinance;